import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import './tfaIntro.scss'

const TfaIntro = props => (
  <Paper elevation={3} component='div' className='tfa-intro'>
    <Box component='div'>
      <Typography variant='h4' gutterBottom>MFA Setup</Typography>
      <Typography variant='body1' gutterBottom>
        Please follow the next steps to activate MFA (Multi-Factor Authentication) for your account
      </Typography>
    </Box>
    <Button
      disabled={props.loading}
      className='action'
      color='primary'
      onClick={props.onStart}
      variant='contained'>
      Start
    </Button>
  </Paper>
)

TfaIntro.propTypes = {
  onStart: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default TfaIntro
